import { ActivatedRoute } from '@angular/router';
import { TelefonosService } from './services/telefonos.service';
import { ActivoUltimaTransmision } from './../../_entities/activos/activo';
import { ActivosService } from './services/activos.service';
import { ContadorSemaforoService } from './services/contador-semaforo.service';
import { MicromedidoresService } from './services/micromedidores.service';
import { MedidoresService } from './services/medidores.service';
import { PuntosInteresService } from './services/puntos-interes.service';
import { finalize, take } from 'rxjs/operators';
import { VehiculosService } from './services/vehiculos.service';
import { User } from './../../_entities/User';
import { Autos } from './../../_entities/autos/Autos';
import { AuthService } from './../auth/auth.service';
import { IconosService } from './services/iconos.service';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MapaService } from './services/mapa.service';
import { Component, OnInit, AfterContentInit, OnDestroy } from '@angular/core';
import { TelefonoUltimaTransmision } from './../../_entities/telefonos/telefono';
import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';
import { DatePipe } from '@angular/common';
import { GSM, GPS, ESTATUS, ALIMENTACION } from './../../_entities/estados';
import { HistoricoPosicionesVehiculoComponent } from './components/popups/vehiculos/historico-posiciones-vehiculo/historico-posiciones-vehiculo.component';
import { HistoricoPosicionesActivoComponent } from './components/popups/activos/historico-posiciones-activo/historico-posiciones-activo.component';
import { HistoricoPosicionesTelefonoComponent } from './components/popups/telefonos/historico-posiciones-telefono/historico-posiciones-telefono.component';
import { PuntosInteresModalComponent } from './components/dialogos/puntos-interes/puntos-interes-modal/puntos-interes-modal.component';
import { ReproduccionComponent } from './components/popups/vehiculos/reproduccion/reproduccion.component';
import { GaleriaVideosComponent } from './components/popups/vehiculos/galeria-videos/galeria-videos.component';
import { Observable } from 'rxjs';
import { HistorialVelocidadesVehiculoComponent } from './components/popups/vehiculos/historial-velocidades-vehiculo/historial-velocidades-vehiculo.component';
import { TerminalService } from './services/terminal.service';
import { UltimaLectura } from './../../_entities/terminal/terminal';
import { FiltroProductosService } from './services/filtro-productos.service';
import { FiltroProductos } from './../../_entities/productos/filtro-productos';
import { PortatilesService } from './services/portatiles.service';
import { PortatilUltimaTransmision } from '../../_entities/Portatiles/Portatil';
declare var $: any;

@Component({
	selector: 'kt-monitoreo',
	templateUrl: './monitoreo.component.html',
	styleUrls: ['./monitoreo.component.scss']
})

export class MonitoreoComponent implements OnInit, AfterContentInit, OnDestroy {
	/*Entidades */
	user: User;
	public autos: Autos[];
	public botones = this.mapaService.mostrandoRecorrido;
	public spinner: boolean = true;
	public loadingVisible: boolean = false;
	private HWUser;
	public videosDisponibles: boolean = false;
	public validarLey: Observable<any>;
	public validarEstadoHistorico: Observable<any>;
	public estadoHistorico: boolean = false;
	public interval = null;

	public usuariosSeleccionados = [];
	public activosDisponibles = [];
	public lectorasDisponibles = [];
	public medidoresDisponibles = [];
	public micromedidoresDisponibles = [];
	public telefonosDisponibles = [];
	public vehiculosDisponibles = [];
	public panelesDisponibles = [];
	public panelesDisponiblesMarcador = [];

	public portatilesDisponibles = [];
	public datosReporte = [];

	constructor(private mapaService: MapaService,
		private authService: AuthService,
		private vehiculosService: VehiculosService,
		private puntosInteresService: PuntosInteresService,
		private medidoresService: MedidoresService,
		private micromedidoresService: MicromedidoresService,
		private iconosService: IconosService,
		private contadorSemaforoService: ContadorSemaforoService,
		private activosService: ActivosService,
		private telefonosService: TelefonosService,
		private terminalService: TerminalService,
		private portatilService: PortatilesService,
		private filtroProductosService: FiltroProductosService,
		private dialogRef: MatDialog,
		private datepipe: DatePipe) {
		this.mapaService.monitoreo = true;

	}

	async ngOnInit() {
		this.validarLey = this.mapaService.validarLey();
		this.validarLey.subscribe((info) => {
			this.videosDisponibles = info;
		});

		this.validarEstadoHistorico = this.mapaService.validarEstadoHistorico();
		this.validarEstadoHistorico.subscribe((info) => {
			this.estadoHistorico = info;
		})

		if (this.mapaService.monitoreo) {
			this.loadingVisible = true;
			this.mapaService.sonProductosFiltrados = false;
			this.user = this.authService.getUser();
			this.HWUser = this.authService.getHWUser();
			this.styleBrand();
			this.mapaService.inicializarMapa();
			this.pintarMarcadoresActivos();
			this.obtenerAlertas();
			this.pintarMarcadoresLectoras();
			this.pintarMarcadoresMedidores();
			this.pintarMarcadoresMicromedidores();
			this.pintarMarcadoresPuntosInteres();
			this.pintarMarcadoresTelefonos();
			this.pintarVehiculos();
			this.pintarMarcadoresPortatiles();
			this.pintarMarcadoresPaneles();
			sessionStorage.removeItem('historico');
			sessionStorage.removeItem('data')
		}
	}

	public styleBrand() {
		var brandBtn = document.getElementById('brandBTN');
		var body = document.body;

		body.classList.add('kt-aside--minimize');
		brandBtn.setAttribute('disabled', 'disabled');
		brandBtn.classList.add('brandBTNClass');
		document.getElementById('listaAlertas').style.display = 'block';
	}

	public ngOnDestroy() {
		this.mapaService.monitoreo = false;
		this.dialogRef.closeAll();
		var brandBtn = document.getElementById('brandBTN'); brandBtn.classList.remove('brandBTNClass');
		document.getElementById('listaAlertas').style.display = 'none';
		this.limpiarArregloAlertas();
		sessionStorage.removeItem('coordinates');
		sessionStorage.removeItem('historico');
		sessionStorage.removeItem('data')
		clearInterval(this.interval);
	}

	ngAfterContentInit() {
		setTimeout(async () => {
			if (this.authService.getCoordinates()) {
				let lng = this.authService.getCoordinates().lng;
				let lat = this.authService.getCoordinates().lat;
				let zoom = this.authService.getCoordinates().zoom;

				await this.mapaService.recargarMapa(lng, lat, zoom);

			} else {
				await this.mapaService.ajustarMapa();
				await this.mapaService.regresarMapa();

			}
			this.loadingVisible = false;
			//this.mostrarOcultarParaSiempre();
		}, 3000);
		if (this.mapaService.historicoMode == false && this.mapaService.monitoreo == true) {
			this.interval = setInterval(async () => {

				if (this.mapaService.sonProductosFiltrados == false) {
					if (this.mapaService.historicoMode == false && this.mapaService.monitoreo == true && this.mapaService.productosVisibles) {
						this.limpiarArregloAlertas();
						await this.mapaService.limpiarDispositivos();
						await this.mapaService.vectorApuntadorAlertaSource.clear();
						await this.obtenerAlertas()
						await this.pintarMarcadoresActivos();
						await this.pintarMarcadoresTelefonos();
						await this.pintarMarcadoresMedidores();
						await this.pintarMarcadoresMicromedidores();
						await this.pintarMarcadoresLectoras();
						//await this.pintarMarcadoresTerminal();
						await this.pintarVehiculos();
						await this.pintarMarcadoresPortatiles();
						await this.pintarMarcadoresPaneles();
						this.mapaService.ocultarUbicadorLayer();
					}
				} else {
					await this.mapaService.vectorApuntadorAlertaSource.clear();
					await this.mapaService.limpiarDispositivos();
					await this.obtenerProductosUsuario();
				}

			}, 20000);
		}
	}

	obtenerProductosUsuario() {
		this.reiniciarArreglos();

		this.filtroProductosService.obtenerPaneles().subscribe(result=>{
			this.panelesDisponibles = result;
		})

		const promise = new Promise((resolve, reject) => {
			this.mapaService.usuariosFlitro.forEach((usuario, index, array) => {
				this.filtroProductosService.obtenerProductosIdUsuario(usuario).pipe(
					finalize(
						() => {
							if (index === array.length - 1) {
								resolve(null);
							}
						}
					)
				).subscribe(
					(productos: any[]) => {
						if (productos.length > 0) {
							this.mapaService.limpiarMapa();
							//this.mapaService.controlEtiquetas = true;
							this.mapaService.registroVehiculos = productos;
							productos.forEach(producto => {
								switch (producto.idProducto) {
									case 2:
										this.vehiculosDisponibles.push(producto);
										break;
									case 3:
										if (producto.bateria == null || producto.bateria == '') {
											producto.bateria = 'Sin Batería'
										} else {
											producto.bateria = producto.bateria + '%'
										}
										const alertaGSMA = GSM.find(gsm => producto.gsm == gsm.id);
										producto.gsm = alertaGSMA.nombre;
										try {
											const alertaGPS = GPS.find(gps => producto.gps == gps.id);
											producto.gps = alertaGPS.nombre;
										} catch (error) {
											producto.gps = 'Mala';
										}
										this.activosDisponibles.push(producto);
										break;
									case 4:
										if (producto.bateria == null || producto.bateria == '') {
											producto.bateria = 'Sin Batería'
										} else {
											producto.bateria = producto.bateria + '%'
										}
										const alertaGSMT = GSM.find(gsm => producto.gsm == gsm.id);
										producto.gsm = alertaGSMT.nombre;
										try {
											const alertaGPS = GPS.find(gps => producto.gps == gps.id);
											producto.gps = alertaGPS.nombre;
										} catch (error) {
											producto.gps = 'Mala';
										}
										switch (producto.estatus) {
											case 0:
												producto.estatus = 'Inactivo';
												break;
											case 1:
												producto.estatus = 'Activo';
												break;
											default:
												producto.estatus = 'Sin datos';

												break;
										}
										this.telefonosDisponibles.push(producto);
										break;
									case 5:
										this.medidoresDisponibles.push(producto);
										break;
									case 6:
										this.micromedidoresDisponibles.push(producto);
										break;
									case 7:
										this.lectorasDisponibles.push(producto);
										break;
									case 8:
										if (producto.bateria == null || producto.bateria == '') {
											producto.bateria = 'Sin Batería'
										} else {
											producto.bateria = producto.bateria + '%'
										}
										const alertaGSMA1 = GSM.find(gsm => producto.gsm == gsm.id);
										producto.gsm = alertaGSMA1.nombre;
										try {
											const alertaGPS = GPS.find(gps => producto.gps == gps.id);
											producto.gps = alertaGPS.nombre;
										} catch (error) {
											producto.gps = 'Mala';
										}
										this.portatilesDisponibles.push(producto);
										break;
							
									default:
										break;
								}

							});
						}
					}, (error) => {
						console.log(error);
					}
				)
			});
		});

		promise.then(() => {
			this.mapaService.sonProductosFiltrados = true;
			this.pintarProductos();
		});
	}

	pintarProductos() {
		if (this.activosDisponibles.length > 0) {
			this.mapaService.activosDisponibles = this.activosDisponibles;
			this.mapaService.pintarMarcadoresActivos();
		}

		if (this.lectorasDisponibles.length > 0) {
			this.mapaService.lectorasDisponibles = this.lectorasDisponibles;
			this.mapaService.pintarMarcadoresLectoras();
		}

		if (this.medidoresDisponibles.length > 0) {
			this.mapaService.medidoresDisponibles = this.medidoresDisponibles;
			this.mapaService.pintarMarcadoresMedidores();
		}

		if (this.micromedidoresDisponibles.length > 0) {
			this.mapaService.micromedidoresDisponibles = this.micromedidoresDisponibles;
			this.mapaService.pintarMarcadoresMicromedidores();
		}

		if (this.telefonosDisponibles.length > 0) {
			this.mapaService.telefonosDisponibles = this.telefonosDisponibles;
			this.mapaService.pintarMarcadoresTelefonos();
		}

		if (this.vehiculosDisponibles.length > 0) {
			this.mapaService.vehiculosDisponibles = this.vehiculosDisponibles;
			this.mapaService.pintarMarcadoresVehiculos();
		}
		if (this.portatilesDisponibles.length > 0) {
			this.mapaService.portatilesDisponibles = this.portatilesDisponibles;
			this.mapaService.pintarMarcadoresPortatiles();
		}

	}

	reiniciarArreglos() {
		this.activosDisponibles = [];
		this.lectorasDisponibles = [];
		this.medidoresDisponibles = [];
		this.micromedidoresDisponibles = [];
		this.telefonosDisponibles = [];
		this.vehiculosDisponibles = [];
		this.portatilesDisponibles = [];
		this.panelesDisponibles = [];
		this.panelesDisponiblesMarcador=[];
	}

	pintarMarcadoresPaneles(){
		this.filtroProductosService.obtenerPanelesMapa().subscribe(result=>{
			this.panelesDisponiblesMarcador = result;
			this.mapaService.pintarPanelCiudadano(this.panelesDisponiblesMarcador);

		})
	}

	pintarMarcadoresActivos() {
		this.activosService.obtenerUltimaTransmisionActivos().subscribe(
			(response: ActivoUltimaTransmision[]) => {
				response.map(function (activo) {
					activo.coordinate = [activo.lng, activo.lat];

					if (activo.bateria == null || activo.bateria == '') {
						activo.bateria = 'Sin Batería'
					} else {
						activo.bateria = activo.bateria + '%'
					}

					switch (activo.estatus) {
						case 0:
							activo.estatus = 'Inactivo';
							break;
						case 1:
							activo.estatus = 'Activo';
							break;
					}
					const alertaGSM = GSM.find(gsm => activo.gsm == gsm.id);
					activo.gsm = alertaGSM.nombre;
					try {
						const alertaGPS = GPS.find(gps => activo.gps == gps.id);
						activo.gps = alertaGPS.nombre;
					} catch (error) {
						activo.gps = 'Mala';
					}

				});
				this.mapaService.pintarActivos(response);
			}

		)
	}


	pintarMarcadoresPortatiles() {
		this.portatilService.obtenerUltimaTransmisionPortatiles().subscribe(
			(response: PortatilUltimaTransmision[]) => {
				response.map(function (activo) {
					activo.coordinate = [activo.lng, activo.lat];

					if (activo.bateria == null || activo.bateria == '') {
						activo.bateria = 'Sin Batería'
					} else {
						activo.bateria = activo.bateria + '%'
					}

					switch (activo.estatus) {
						case 0:
							activo.estatus = 'Inactivo';
							break;
						case 1:
							activo.estatus = 'Activo';
							break;
					}
					const alertaGSM = GSM.find(gsm => activo.gsm == gsm.id);
					activo.gsm = alertaGSM.nombre;
					try {
						const alertaGPS = GPS.find(gps => activo.gps == gps.id);
						activo.gps = alertaGPS.nombre;
					} catch (error) {
						activo.gps = 'Mala';
					}

				});
				this.mapaService.pintarPortatiles(response);
			}

		)
	}



	pintarMarcadoresLectoras() {
		this.terminalService.getTerminales().subscribe(
			(terminales) => {
				this.obtenerTags(terminales);
			}, (err) => {
				console.log(err);

			}
		)
	}

	obtenerTags(terminales) {
		const START_DATE = `${new Date().getFullYear().toString()}-01-01 00:00:00`;
		const END_DATE = this.datepipe.transform(new Date(), 'yyyy-MM-dd HH:mm:ss');

		terminales.forEach(terminal => {
			this.terminalService.getHistoricRecords(terminal.id, START_DATE, END_DATE).subscribe(
				(records: UltimaLectura[]) => {
					records.map(terminal => {
						const estatus = ESTATUS.find(estatus => estatus.id === terminal.estatus);
						terminal.estatus = estatus.nombre
						terminal.colorEstatus = estatus.clase;

						const gsm = GSM.find(gsm => gsm.id === terminal.gsm);
						terminal.gsm = gsm.nombre;

						try {
							const alertaGPS = GPS.find(gps => terminal.gps == gps.id);
							terminal.gps = alertaGPS.nombre;
						} catch (error) {
							terminal.gps = 'Mala';
						}

						const alimentacion = ALIMENTACION.find(alimentacion => alimentacion.id === terminal.alimentacion);
						terminal.alimentacion = alimentacion.nombre;

						terminal.fechaHora = this.datepipe.transform(terminal.fechaHora, 'dd-MM-yyyy h:mm:ss a');
					});
					this.mapaService.pintarLectoras(records);


				}, (err) => {
					console.error(err);
				}
			);
		})
	}

	pintarMarcadoresMedidores() {
		this.medidoresService.getMedidores().subscribe(
			(response: any[]) => {
				this.mapaService.pintarMedidores(response);
			}, (error) => {
				console.log('error en pintar medidores ', error);

			}
		);
	}

	pintarMarcadoresMicromedidores() {
		let newResponse = [];
		let temNumSeries = [];
		this.micromedidoresService.obtenerMicromedidores().subscribe(
			(micromedidores: any[]) => {
				micromedidores.map(function (micrommedidor) {
					if (micrommedidor.tamper == null || micrommedidor.tamper == '') {
						micrommedidor.tamper = 'Sin datos'
					}

					if (micrommedidor.observacion == null || micrommedidor.observacion == '') {
						micrommedidor.observacion = 'Sin datos'
					}

					if (micrommedidor.contador == null || micrommedidor.contador == '') {
						micrommedidor.contador = 'Sin datos'
					}


					if (micrommedidor.estatus == 1) {
						micrommedidor.estatus = 'Activo'
					} else {
						micrommedidor.estatus = 'Inactivo'

					}
				});

				micromedidores.forEach(
					micromedidor => {
						let numeroSerie = micromedidor.numeroSerie;

						if (!(temNumSeries.includes(numeroSerie))) {
							temNumSeries.push(numeroSerie);
							newResponse.push(micromedidor);
						}
					}
				);
				this.mapaService.pintarMicromedidores(newResponse);
			}
		);
	}

	pintarMarcadoresPuntosInteres() {
		this.puntosInteresService.getPuntos().subscribe(
			(res: any[]) => {
				this.mapaService.pintarPuntosInteres(res);
			}, err => { });
	}

	pintarMarcadoresTelefonos() {
		this.telefonosService.obtenerUltimaTransmisionTelefonos().subscribe(
			(response: TelefonoUltimaTransmision[]) => {
				response.map(function (telefono) {
					telefono.coordinate = [telefono.lng, telefono.lat];
					switch (telefono.estatus) {
						case 0:
							telefono.estatus = 'Inactivo';
							break;
						case 1:
							telefono.estatus = 'Activo';
							break;
						default:
							break;
					}

					if (telefono.bateria == null || telefono.bateria == '') {
						telefono.bateria = 'Sin Batería'
					} else {
						telefono.bateria = telefono.bateria + '%'
					}


					const alertaGSM = GSM.find(gsm => telefono.gsm == gsm.id);
					telefono.gsm = alertaGSM.nombre;

					try {
						const alertaGPS = GPS.find(gps => telefono.gps == gps.id);
						telefono.gps = alertaGPS.nombre;
					} catch (error) {
						telefono.gps = 'Mala';
					}


				});
				this.mapaService.pintarTelefonos(response);
			}
		)
	}

	pintarVehiculos() {
		/*let token = ''
		if (this.HWUser) {
			token = this.HWUser.token;
		}*/
		this.vehiculosService.obtenerAutos().subscribe(
			(vehiculos: Autos[]) => {
				if (vehiculos.length) {
					/*vehiculos.forEach(vehiculo => {
						this.contadorSemaforo(vehiculo.estado);
					});*/
					this.mapaService.pintarVehiculos(vehiculos);
				}
			}, err => {
				console.log(err);
			}
		);
	}

	mostrarOcultarParaSiempre() {
		let toggleParaSiempre = Number(sessionStorage.getItem('toggleParaSiempre'))
		if (toggleParaSiempre == -1) {
			this.mapaService.mostrarParaSiempre();
		} else if (toggleParaSiempre == 1) {
			this.mapaService.ocultarParaSiempre();
		}
	}

	limpiarArregloAlertas() {
		this.iconosService.alertaPrincipal = [];
		this.iconosService.alertaGeocerca = [];
	}

	obtenerAlertas() {
		/*let token = ''
		if (this.HWUser) {
			token = this.HWUser.token;
		}*/
		this.vehiculosService.obtenerAlertas().subscribe(
			(response) => {
				this.mapaService.registroVehiculos = response;
			}
		)
	}

	public contadorSemaforo(estado: number) {
		switch (estado) {
			case 0:
				this.contadorSemaforoService.gris++;
				this.contadorSemaforoService.gris = this.contadorSemaforoService.gris;
				break;
			case 1:
				this.contadorSemaforoService.verde++;
				this.contadorSemaforoService.verde = this.contadorSemaforoService.verde;
				break;
			case 2:
				this.contadorSemaforoService.rojoParpadeante++;
				this.contadorSemaforoService.rojoParpadeante = this.contadorSemaforoService.rojoParpadeante;
				break;
			case 3:
				this.contadorSemaforoService.amarilloParpadeante++;
				this.contadorSemaforoService.amarilloParpadeante = this.contadorSemaforoService.amarilloParpadeante;
				break;
			case 4:
				this.contadorSemaforoService.amarillo++;
				this.contadorSemaforoService.amarillo = this.contadorSemaforoService.amarillo;
				break;
			case 5:
				this.contadorSemaforoService.naranja++;
				this.contadorSemaforoService.naranja = this.contadorSemaforoService.naranja;
				break;
			case 6:
				this.contadorSemaforoService.rojo++;
				this.contadorSemaforoService.rojo = this.contadorSemaforoService.rojo;
				break;
			case 7:
				this.contadorSemaforoService.azul++;
				this.contadorSemaforoService.azul = this.contadorSemaforoService.azul;
				break;
			case 8:
				this.contadorSemaforoService.violeta++;
				this.contadorSemaforoService.violeta = this.contadorSemaforoService.violeta;
				break;
		}
	}

	public abrirHistorico() {
		/*Historico Popup*/
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "55%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;

		switch (this.mapaService.tipoProducto) {
			case 'vehiculo':
				this.dialogRef.open(HistoricoPosicionesVehiculoComponent, dialogConfig);
				break;
			case 'activo':
				this.dialogRef.open(HistoricoPosicionesActivoComponent, dialogConfig);
				break;
			case 'telefono':
				this.dialogRef.open(HistoricoPosicionesTelefonoComponent, dialogConfig);
				break;
			case 'reproduccion':
				this.dialogRef.open(ReproduccionComponent, dialogConfig);
				break;
		}
	}

	abrirVideos() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "55%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		this.dialogRef.open(GaleriaVideosComponent, dialogConfig);
	}

	abrirGraficaVelocidad() {
		const dialogConfig = new MatDialogConfig();
		dialogConfig.autoFocus = true;
		dialogConfig.disableClose = true;
		dialogConfig.width = "55%";
		dialogConfig.panelClass = 'custom-modalbox';
		dialogConfig.closeOnNavigation = true;
		dialogConfig.hasBackdrop = false;
		this.dialogRef.open(HistorialVelocidadesVehiculoComponent, dialogConfig);
	}

	public imprimirRecorrido() {
		switch (this.mapaService.tipoProducto) {
			case 'vehiculo':
				this.imprimirVehiculo();
				break;
			case 'activo':
				this.imprimirActivo();
				break;
			case 'telefono':
				this.imprimirTelefono();
				break;
			case 'Portatiles':
				this.imprimirPortatil();
				break;
		}

	}

	validarDato(dato) {
		if (dato == null) {
			dato = ''
		}
		return dato;
	}

	imprimirVehiculo() {
		this.loadingVisible = true;
		this.mapaService.ocultarPuntosInteres();
		const PLACA = this.validarDato(this.mapaService.datosGenerales.placas);
		const ECONOMICO = this.validarDato(this.mapaService.datosGenerales.economico);
		const SERIE = this.validarDato(this.mapaService.datosGenerales.numeroSerie);
		const MARCA = this.validarDato(this.mapaService.datosGenerales.marca);
		const MODELO = this.validarDato(this.mapaService.datosGenerales.modelo);
		const ANIO = this.validarDato(this.mapaService.datosGenerales.anio);
		const COLOR = this.validarDato(this.mapaService.datosGenerales.color);
		const DESCRIPCION = this.validarDato(this.mapaService.datosGenerales.descripcion);
		const FECHA_INICIAL = this.validarDato(this.datepipe.transform(this.mapaService.historicoFechas[0], 'dd/MM/yyyy h:MM a'));
		const FECHA_FINAL = this.validarDato(this.datepipe.transform(this.mapaService.historicoFechas[1], 'dd/MM/yyyy h:MM a'));
		let fechaHora = this.mapaService.datosGenerales.fechaHoraUltimaPosicion;
		let dir = '';
		let dir2 = '';

		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');
		let direccion;

		this.mapaService.getDireccion([this.mapaService.datosGenerales.lng, this.mapaService.datosGenerales.lat]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
				const fragmentDirection = direccion.split(',');
				let cont = 0;
				while (cont <= 1) {
					dir = dir + fragmentDirection[cont] + ', '
					cont++;
				}

				while (cont < fragmentDirection.length) {
					dir2 = dir2 + fragmentDirection[cont] + ', '
					cont++;
				}

			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);


		const mapElement = document.getElementById('map');
		html2canvas(mapElement, { useCORS: true }).then(
			(canvas) => {
				let pdf = new jsPDF('p', 'pt', 'a4');

				const logoGTM = './assets/media/logos/logo-gtm.png'
				const logoGTMX = 20;
				const logoGTMY = 15;
				const logoGTMWidth = 180;
				const logoGTMHeight = 80;
				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

				pdf.setFontSize(20);
				pdf.setFont('', 'bold')

				pdf.text('Historial de Posiciones', 190, 120);
				pdf.text('Inicio: ' + FECHA_INICIAL + ', Fin: ' + FECHA_FINAL, 55, 145);


				const logoGTMWater = './assets/media/logos/marca-de-agua.png'
				const logoGTMWaterX = 15;
				const logoGTMWaterY = 130;
				const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
				const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
				const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
				pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 165;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;
				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Datos del Dispositivo', 90, 470,);

				pdf.setFont('', 'normal')
				pdf.text('Vehículo:', 90, 485);
				pdf.text(MARCA + ', ' + MODELO, 300, 485);

				pdf.text('Placa:', 90, 500);
				pdf.text(PLACA, 300, 500);

				pdf.text('Económico:', 90, 515);
				pdf.text(ECONOMICO, 300, 515);

				pdf.text('Número de Serie:', 90, 530);
				pdf.text(SERIE, 300, 530);

				pdf.text('Año:', 90, 545);
				pdf.text(ANIO + '', 300, 545);

				pdf.text('Color:', 90, 560);
				pdf.text(COLOR, 300, 560);

				pdf.text('Descripción:', 90, 575);
				pdf.text(DESCRIPCION, 300, 575);

				pdf.text('Dirección:', 90, 590);
				pdf.text(dir + '', 300, 590);
				pdf.text(dir2, 87, 605);

				pdf.setFontSize(12);
				pdf.setFont('sans-serif', 'bold');

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				return pdf;

			}
		).then(
			(pdf) => {
				const nombreArchivo = 'Historico'
				pdf.save(nombreArchivo + '.pdf');
				this.mapaService.mostrarPuntosInteres();
				this.loadingVisible = false;
			}
		);

	}

	imprimirActivo() {
		this.loadingVisible = true;

		const IMEI = this.mapaService.datosGenerales.imei;
		const ECONOMICO = this.mapaService.datosGenerales.economico;
		const SERIE = this.mapaService.datosGenerales.numeroSerie;
		const MODELO = this.mapaService.datosGenerales.modelo;
		const CLIENTE = this.mapaService.datosGenerales.cliente;
		const DESCRIPCION = this.mapaService.datosGenerales.descripcion;
		const FECHA_INICIAL = this.mapaService.historicoFechas[0];
		const FECHA_FINAL = this.mapaService.historicoFechas[1];
		let fechaHora = this.mapaService.datosGenerales.fechaHoraUltimaPosicion;
		let dir = '';
		let dir2 = '';


		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');
		let direccion;

		this.mapaService.getDireccion([this.mapaService.datosGenerales.lng, this.mapaService.datosGenerales.lat]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
				const fragmentDirection = direccion.split(',');
				let cont = 0;
				while (cont <= 1) {
					dir = dir + fragmentDirection[cont] + ', '
					cont++;
				}

				while (cont < fragmentDirection.length) {
					dir2 = dir2 + fragmentDirection[cont] + ', '
					cont++;
				}

			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);


		const mapElement = document.getElementById('map');
		html2canvas(mapElement, { useCORS: true }).then(
			(canvas) => {
				let pdf = new jsPDF('p', 'pt', 'a4');

				const logoGTM = './assets/media/logos/logo-gtm.png'
				const logoGTMX = 20;
				const logoGTMY = 15;
				const logoGTMWidth = 180;
				const logoGTMHeight = 80;
				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Historial de posiciones de [' + FECHA_INICIAL + '] a [' + FECHA_FINAL + ']', 80, 120,);

				const logoGTMWater = './assets/media/logos/marca-de-agua.png'
				const logoGTMWaterX = 15;
				const logoGTMWaterY = 130;
				const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
				const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
				const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
				pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 130;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;
				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Datos del Dispositivo', 90, 470,);

				pdf.setFont('', 'normal')
				pdf.text('Activo:', 90, 485);
				pdf.text(MODELO, 300, 485);

				pdf.text('Placa:', 90, 500);
				pdf.text(IMEI + '', 300, 500);

				pdf.text('Económico:', 90, 515);
				pdf.text(ECONOMICO, 300, 515);

				pdf.text('Número de Serie:', 90, 530);
				pdf.text(SERIE, 300, 530);

				pdf.text('Cliente:', 90, 545);
				pdf.text(CLIENTE, 300, 545);

				pdf.text('Descripción:', 90, 560);
				pdf.text(DESCRIPCION, 300, 560);

				pdf.text('Dirección:', 90, 575);
				pdf.text(dir + '', 300, 575);
				pdf.text(dir2, 87, 590);

				pdf.setFontSize(12);
				pdf.setFont('sans-serif', 'bold');

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				return pdf;

			}
		).then(
			(pdf) => {
				const nombreArchivo = 'Historico'
				pdf.save(nombreArchivo + '.pdf');
				this.loadingVisible = false;
			}
		);
	}

	imprimirPortatil() {
		this.loadingVisible = true;

		const IMEI = this.mapaService.datosGenerales.imei;
		const ECONOMICO = this.mapaService.datosGenerales.economico;
		const SERIE = this.mapaService.datosGenerales.numeroSerie;
		const MODELO = this.mapaService.datosGenerales.modelo;
		const CLIENTE = this.mapaService.datosGenerales.cliente;
		const DESCRIPCION = this.mapaService.datosGenerales.descripcion;
		const FECHA_INICIAL = this.mapaService.historicoFechas[0];
		const FECHA_FINAL = this.mapaService.historicoFechas[1];
		let fechaHora = this.mapaService.datosGenerales.fechaHoraUltimaPosicion;
		let dir = '';
		let dir2 = '';


		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');
		let direccion;

		this.mapaService.getDireccion([this.mapaService.datosGenerales.lng, this.mapaService.datosGenerales.lat]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
				const fragmentDirection = direccion.split(',');
				let cont = 0;
				while (cont <= 1) {
					dir = dir + fragmentDirection[cont] + ', '
					cont++;
				}

				while (cont < fragmentDirection.length) {
					dir2 = dir2 + fragmentDirection[cont] + ', '
					cont++;
				}

			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);


		const mapElement = document.getElementById('map');
		html2canvas(mapElement, { useCORS: true }).then(
			(canvas) => {
				let pdf = new jsPDF('p', 'pt', 'a4');

				const logoGTM = './assets/media/logos/logo-gtm.png'
				const logoGTMX = 20;
				const logoGTMY = 15;
				const logoGTMWidth = 180;
				const logoGTMHeight = 80;
				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Historial de posiciones de [' + FECHA_INICIAL + '] a [' + FECHA_FINAL + ']', 80, 120,);

				const logoGTMWater = './assets/media/logos/marca-de-agua.png'
				const logoGTMWaterX = 15;
				const logoGTMWaterY = 130;
				const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
				const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
				const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
				pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 130;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;
				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Datos del Dispositivo', 90, 470,);

				pdf.setFont('', 'normal')
				pdf.text('Activo:', 90, 485);
				pdf.text(MODELO, 300, 485);

				pdf.text('Placa:', 90, 500);
				pdf.text(IMEI + '', 300, 500);

				pdf.text('Económico:', 90, 515);
				pdf.text(ECONOMICO, 300, 515);

				pdf.text('Número de Serie:', 90, 530);
				pdf.text(SERIE, 300, 530);

				pdf.text('Cliente:', 90, 545);
				pdf.text(CLIENTE, 300, 545);

				pdf.text('Descripción:', 90, 560);
				pdf.text(DESCRIPCION, 300, 560);

				pdf.text('Dirección:', 90, 575);
				pdf.text(dir + '', 300, 575);
				pdf.text(dir2, 87, 590);

				pdf.setFontSize(12);
				pdf.setFont('sans-serif', 'bold');

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				return pdf;

			}
		).then(
			(pdf) => {
				const nombreArchivo = 'Historico'
				pdf.save(nombreArchivo + '.pdf');
				this.loadingVisible = false;
			}
		);
	}

	imprimirTelefono() {
		this.loadingVisible = true;

		const IMEI = this.mapaService.datosGenerales.imei;
		const ECONOMICO = this.mapaService.datosGenerales.economico;
		const SERIE = this.mapaService.datosGenerales.numeroSerie;
		const MODELO = this.mapaService.datosGenerales.modelo;
		const CLIENTE = this.mapaService.datosGenerales.cliente;
		const DESCRIPCION = this.mapaService.datosGenerales.descripcion;
		const FECHA_INICIAL = this.mapaService.historicoFechas[0];
		const FECHA_FINAL = this.mapaService.historicoFechas[1];
		let fechaHora = this.mapaService.datosGenerales.fechaHoraUltimaPosicion;
		let direccion;
		let dir = '';
		let dir2 = '';

		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');

		this.mapaService.getDireccion([this.mapaService.datosGenerales.lng, this.mapaService.datosGenerales.lat]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";
				const fragmentDirection = direccion.split(',');
				let cont = 0;
				while (cont <= 1) {
					dir = dir + fragmentDirection[cont] + ', '
					cont++;
				}

				while (cont < fragmentDirection.length) {
					dir2 = dir2 + fragmentDirection[cont] + ', '
					cont++;
				}

			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);

		const mapElement = document.getElementById('map');
		html2canvas(mapElement, { useCORS: true }).then(
			(canvas) => {
				let pdf = new jsPDF('p', 'pt', 'a4');

				const logoGTM = './assets/media/logos/logo-gtm.png'
				const logoGTMX = 20;
				const logoGTMY = 15;
				const logoGTMWidth = 180;
				const logoGTMHeight = 80;
				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Historial de posiciones de [' + FECHA_INICIAL + '] a [' + FECHA_FINAL + ']', 80, 120,);

				const logoGTMWater = './assets/media/logos/marca-de-agua.png'
				const logoGTMWaterX = 15;
				const logoGTMWaterY = 130;
				const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
				const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
				const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
				pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 130;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;
				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Datos del Dispositivo', 90, 470,);

				pdf.setFont('', 'normal')
				pdf.text('Activo:', 90, 485);
				pdf.text(MODELO, 300, 485);

				pdf.text('Placa:', 90, 500);
				pdf.text(IMEI + '', 300, 500);

				pdf.text('Económico:', 90, 515);
				pdf.text(ECONOMICO, 300, 515);

				pdf.text('Número de Serie:', 90, 530);
				pdf.text(SERIE, 300, 530);

				pdf.text('Cliente:', 90, 545);
				pdf.text(CLIENTE, 300, 545);

				pdf.text('Descripción:', 90, 560);
				pdf.text(DESCRIPCION, 300, 560);

				pdf.text('Dirección:', 90, 575);
				pdf.text(dir + '', 300, 575);
				pdf.text(dir2, 87, 590);

				pdf.setFontSize(12);
				pdf.setFont('sans-serif', 'bold');

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				return pdf;

			}
		).then(
			(pdf) => {
				const nombreArchivo = 'Historico'
				pdf.save(nombreArchivo + '.pdf');
				this.loadingVisible = false;
			}
		);
	}

	imprimirMedidor() {
		this.loadingVisible = true;

		const IMEI = this.mapaService.datosGenerales.imei;
		const ECONOMICO = this.mapaService.datosGenerales.economico;
		const SERIE = this.mapaService.datosGenerales.numeroSerie;
		const MODELO = this.mapaService.datosGenerales.modelo;
		const CLIENTE = this.mapaService.datosGenerales.cliente;
		const DESCRIPCION = this.mapaService.datosGenerales.descripcion;
		const FECHA_INICIAL = this.mapaService.historicoFechas[0];
		const FECHA_FINAL = this.mapaService.historicoFechas[1];
		let fechaHora = this.mapaService.datosGenerales.fechaHoraUltimaPosicion;
		let direccion;
		let dir = '';
		let dir2 = '';

		fechaHora = this.datepipe.transform(fechaHora, 'yyyy-MM-dd h:mma');

		this.mapaService.getDireccion([this.mapaService.datosGenerales.lng, this.mapaService.datosGenerales.lat]).then(
			(data: any) => {
				direccion = data.display_name || "Dirección Desconocida";

				const fragmentDirection = direccion.split(',');
				let cont = 0;
				while (cont <= 1) {
					dir = dir + fragmentDirection[cont] + ', '
					cont++;
				}

				while (cont < fragmentDirection.length) {
					dir2 = dir2 + fragmentDirection[cont] + ', '
					cont++;
				}

			},
			() => {
				direccion = "Dirección Desconocida";
			}
		);


		const mapElement = document.getElementById('map');
		html2canvas(mapElement, { useCORS: true }).then(
			(canvas) => {
				let pdf = new jsPDF('p', 'pt', 'a4');

				const logoGTM = './assets/media/logos/logo-gtm.png'
				const logoGTMX = 20;
				const logoGTMY = 15;
				const logoGTMWidth = 180;
				const logoGTMHeight = 80;
				pdf.addImage(logoGTM, 'PNG', logoGTMX, logoGTMY, logoGTMWidth, logoGTMHeight, 'MEDIUM');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Historial de posiciones de [' + FECHA_INICIAL + '] a [' + FECHA_FINAL + ']', 80, 120,);

				const logoGTMWater = './assets/media/logos/marca-de-agua.png'
				const logoGTMWaterX = 15;
				const logoGTMWaterY = 130;
				const logoGTMWaterProp = (pdf as any).getImageProperties(logoGTMWater);
				const logoGTMWaterWidth = pdf.internal.pageSize.getWidth() - 2 * logoGTMWaterX;
				const logoGTMWaterHeight = (logoGTMWaterProp.height * logoGTMWaterWidth) / logoGTMWaterProp.width;
				pdf.addImage(logoGTMWater, 'PNG', logoGTMWaterX, logoGTMWaterY, logoGTMWaterWidth, logoGTMWaterHeight, 'SLOW');

				const mapa = canvas.toDataURL('image/PNG');
				const mapaX = 15;
				const mapaY = 130;
				const mapaProps = (pdf as any).getImageProperties(mapa);
				const mapaWidth = pdf.internal.pageSize.getWidth() - 2 * mapaX;
				const mapaHeight = (mapaProps.height * mapaWidth) / mapaProps.width;
				pdf.addImage(mapa, 'PNG', mapaX, mapaY, mapaWidth, mapaHeight, 'FAST');

				pdf.setFontSize(14);
				pdf.setFont('', 'bold')
				pdf.text('Datos del Dispositivo', 90, 470,);

				pdf.setFont('', 'normal')
				pdf.text('Activo:', 90, 485);
				pdf.text(MODELO, 300, 485);

				pdf.text('Placa:', 90, 500);
				pdf.text(IMEI + '', 300, 500);

				pdf.text('Económico:', 90, 515);
				pdf.text(ECONOMICO, 300, 515);

				pdf.text('Número de Serie:', 90, 530);
				pdf.text(SERIE, 300, 530);

				pdf.text('Cliente:', 90, 545);
				pdf.text(CLIENTE, 300, 545);

				pdf.text('Descripción:', 90, 560);
				pdf.text(DESCRIPCION, 300, 560);

				pdf.text('Dirección:', 90, 575);
				pdf.text(dir + '', 300, 575);
				pdf.text(dir2, 87, 590);

				pdf.setFontSize(12);
				pdf.setFont('sans-serif', 'bold');

				pdf.text('GTM Tecnología S.A. de C.V.', 220, 795);
				pdf.text('Carr. Temixco - Emiliano Zapata ext. 17 int. 3B Col. Palo Escrito, Emiliano Zapata, Mor, Mex. C.P. 62760', 22, 810);
				pdf.text('Tel. +52 7773200301, Whatsapp: +52 7771351886, monitoreo@gtmtec.mx', 65, 825);

				return pdf;

			}
		).then(
			(pdf) => {
				const nombreArchivo = 'Historico'
				pdf.save(nombreArchivo + '.pdf');
				this.loadingVisible = false;
			}
		);
	}

	obtenerCoordenadaPixel() {
		$('body').removeClass('open-submenu');
		$('[data-toggle=w-dropdown], .w-dropdown-menu').removeClass('open');
		this.mapaService.puntosInteres();
	}

	public historicoStreetView() {
		this.mapaService.historicoStreetView();
	}

	public irInicioRecorrido() {
		this.mapaService.irInicioRecorrido();
		this.mapaService.map.updateSize();
	}

	public irAnterior() {
		this.mapaService.irAnterior();
	}

	public irSiguiente() {
		this.mapaService.irSiguiente();

	}

	public irFinalRecorrido() {
		this.mapaService.irFinalRecorrido();
	}

	public cerrarRecorrido() {
		sessionStorage.removeItem('historico');
		sessionStorage.removeItem('data')
		this.mapaService.cerrarRecorrido();
		const botonesRecorrido = document.getElementById('botonesRecorrido');
		botonesRecorrido.style.display = 'none';

		document.getElementById('style-7').classList.remove('menu-barHidde');
		document.getElementById('map-content').classList.remove('map-recorrido');
		this.mapaService.map.getView().setZoom(8)
		this.videosDisponibles = false;
		this.estadoHistorico = false;
	}


	public cerrarPopup() {
		this.mapaService.undefinedPopup();
	}
}
